export const status = {
  unconfirmed: ['pending', 'reserved'],
  confirmed: ['confirmed'],
  active: ['inProgress', 'partiallyShipped', 'shipped', 'partiallyDelivered'],
  completed: ['delivered'],
  cancelled: ['cancelled']
}
